import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const { googleLogin } = useAuth();
  const nav = useNavigate();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.startsWith("#") ? hash.slice(1) : hash);
    const sid = params.get("session_id");
    if (!sid) { toast.error("Missing session id"); nav("/login"); return; }
    (async () => {
      try {
        await googleLogin(sid);
        toast.success("Signed in with Google");
        window.history.replaceState({}, "", "/jobs");
        nav("/jobs", { replace: true });
      } catch (err) {
        toast.error(err?.response?.data?.detail || "Google sign-in failed");
        nav("/login", { replace: true });
      }
    })();
  }, [googleLogin, nav]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div data-testid="auth-callback-loading" className="nb-card p-6 font-bold">Signing you in…</div>
    </div>
  );
}
